/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询订单详情信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  orderDetailSeatDto: order.OrderDetailSeatDto,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: order.OrderDetailExpertResponse;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/order/order-detail-seat`,
    data: orderDetailSeatDto,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
